<template>
  <div>
    <div align="right"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Frequently Asked Question</h5>
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="1"></b-col>
        <b-col md="2" align="right" class="my-1">
          <b-input-group>
            <b-input-group-text class="bg-white border-right-0" slot="prepend">
              <img src="@/assets/filter.svg" alt />
            </b-input-group-text>
            <b-dropdown
              text="Filter Data"
              variant="light"
              toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
              slot="append"
            >
              <b-dropdown-item @click="allCategory()">All Category</b-dropdown-item>
              <b-dropdown-item
                @click="FaqFilter(filter.id)"
                v-for="filter in datafilter"
                :key="filter"
              >{{filter.category_name.id}}</b-dropdown-item>
            </b-dropdown>
          </b-input-group>
        </b-col>
        <b-col md="3" class="my-1" align="right">
          <router-link :to="{name: 'createFaq'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New FAQ
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive="sm"
        show-empty
        ref="FaqContent"
        hover
        :items="getInfo"
        :fields="faq"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(image)="row">
          <b-img :src="row.value" width="75px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(question.id)="row">
          <div v-html="row.value.substring(0,20)"></div>
        </template>
        <template v-slot:cell(answer.id)="row">
          <div v-html="row.value.substring(0,20)"></div>
        </template>
        <template v-slot:cell(created_at_date_only)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>
          by {{item.created_by_username}}
        </template>
        <template v-slot:cell(updated_at_date_only)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>
            by {{item.updated_by_username}}
          </div>
        </template>
        <template v-slot:cell(action)="{value,item}">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editFaq', params: {id: item.id}}"
            class="text-dark"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <b-link
            v-b-tooltip.hover
            title="View Detail"
            @click="modalShow = !modalShow"
            class="text-dark mr-2"
          >
            <img @click="getDetail(item.id)" src="@/assets/ic-view-detail.svg" alt />
          </b-link>
          <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img src="@/assets/rectangle.svg" class="mr-2" alt />
          </b-link>
          <b-link
            :class="{'order-link':item.order_field === 1}"
            @click="orderFaq({id:item.id,change:'up'})"
            class="text-primary"
            v-b-tooltip.hover
            title="Up Order"
          >
            <i class="fas fa-arrow-up mr-2"></i>
          </b-link>
          <b-link
            :class="{'order-link':item.is_last_order}"
            @click="orderFaq({id:item.id,change:'down'})"
            class="text-primary"
            v-b-tooltip.hover
            title="Down Order"
          >
            <i class="fas fa-arrow-down"></i>
          </b-link>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal v-model="modalShow" size="lg" ok-only hide-header>
      <b-row>
        <b-col>
          <h5 class="font-weight-bold">Preview</h5>
        </b-col>
        <b-col class="text-right">
          <i class="fas fa-times" @click="modalShow = !modalShow" style="cursor: pointer;"></i>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-row>
            <b-col md="12" class="font-weight-bold">Question:</b-col>
            <b-col md="4" class="font-weight-bold">In Bahasa</b-col>
            <b-col md="8">{{modalShow ? detail.question.id:''}}</b-col>
            <b-col md="4" class="font-weight-bold">In English</b-col>
            <b-col md="8">{{modalShow ? detail.question.en:''}}</b-col>
            <br />
            <br />
            <b-col md="12" class="font-weight-bold">Answer:</b-col>
            <b-col md="4" class="font-weight-bold">In Bahasa</b-col>
            <b-col md="8" v-html="modalShow ? detail.answer.id:''"></b-col>
            <b-col md="4" class="font-weight-bold">In English</b-col>
            <b-col md="8" v-html="modalShow ? detail.answer.en:''"></b-col>
            <br />
            <br />
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      faq: [
        {
          key: "created_at_date_only",
          label: "Created",
          sortable: true,
          class: "text-left"
        },
        {
          key: "category.category_name.id",
          label: "Category (Bahasa)",
          sortable: true,
          class: "text-left"
        },
        {
          key: "question.id",
          label: "Question (Bahasa)",
          sortable: true,
          class: "text-left"
        },
        {
          key: "answer.id",
          label: "Answer (Bahasa)",
          sortable: true,
          class: "text-left"
        },
        {
          key: "image",
          label: "Image",
          class: "text-left"
        },
        {
          key: "order_field",
          label: "Order Number",
          sortable: true,
          class: "text-left"
        },
        {
          key: "updated_at_date_only",
          label: "Updated",
          sortable: true,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      faq_category_id: "",
      filter: "",
      detail: [],
      datafilter: [],
      customerShow: false,
      modalShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  beforeCreate() {
    // this.$store
    //   .dispatch("FaqModule/getFaqs")
    //   .then(response => {
    //     this.loading = false;
    //   })
    //   .catch(error => {
    //     this.$swal({
    //       type: "error",
    //       title: "Oops...",
    //       text: error.response.data.message,
    //       showConfirmButton: false,
    //       timer: 1500
    //     });
    //     this.loading = false;
    //   });
    this.$store
      .dispatch("FaqModule/getFaqCategoryDatas")
      .then(response => {
        this.loading = false;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.loading = false;
      });
  },
  created() {
    this.$store.watch(
      state => state.FaqModule.faq_category,
      (newValue, oldValue) => {
        this.datafilter = newValue;
      }
    );
  },
  methods: {
    getDetail(payload) {
      this.$store
        .dispatch("FaqModule/getFaq", payload)
        .then(response => {
          this.detail = response;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("faq_category_id", this.faq_category_id);
      this.$store
        .dispatch("FaqModule/getFaqs", formData)
        .then(response => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch(error => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    allCategory() {
      this.faq_category_id = "";
      this.$refs.FaqContent.refresh();
    },
    FaqFilter(payload) {
      this.faq_category_id = payload;
      this.$refs.FaqContent.refresh();
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    orderFaq(order) {
      this.loading = true;
      const orderData = {
        change_type: order.change
      };
      this.$store
        .dispatch("FaqModule/orderFaq", {
          id: order.id,
          orderData
        })
        .then(response => {
          this.$refs.FaqContent.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
          });
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.serverError = error.response.data;
          console.log(error);
        });
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("FaqModule/delFaq", id);
          this.$refs.FaqContent.refresh();
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    }
  }
};
</script>

<style>
</style>
